import axios from 'axios'

// Export de l'instance axios au cas où on doit l'utiliser
// ailleurs que dans l'API
export default axios.create({
  baseURL: (process.env.NODE_ENV === 'development' ? 'http://localhost:80' : '') + '/api',
  withCredentials: true
})
